import React, { useEffect, useCallback, useState } from 'react';
import Button from '../shared/button/button';
import Input from '../shared/input/input';
import CustomDatePicker from '../shared/date-picker/date-picker';
import { getDateYesterday } from '../../utils/time';
import { classnames } from '../../utils/classnames';
import Cross from '../shared/cross';
import { prescriptionSubmitRedirect } from '../../utils/location';
import Validators from '../../utils/validation';

export default function PrescriptionsWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({
    dob: getDateYesterday(),
    idNumber: '',
  });
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const isValidDate = data.dob;
    const isValidId = data.idNumber;
    setIsDisabled(!(isValidDate && isValidId));
  }, [data]);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClickClose = () => {
    setIsOpen(false);
  };
  const handleChange = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    prescriptionSubmitRedirect(data.dob, data.idNumber);
  };

  return (
    <>
      <div className={classnames('hero__prescriptions', 'hero__widget-block', isOpen && 'js-active')}>
        <div className="hero__widget-header" onClick={handleOpen}>
          <svg
            className="hero__prescriptions-icon"
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_807_5801)">
              <path
                d="M18.5575 9.61472L20.2871 9.96134C20.7197 9.63943 20.9997 9.12691 20.9997 8.54945C20.9997 7.66313 20.3024 6.92966 19.4433 6.80365L9.10831 4.68546C9.10831 4.68546 8.91269 4.66675 8.84713 4.66675C8.01085 4.66675 7.03386 6.40962 6.83325 7.16675L18.5575 9.61472Z"
                fill="#C4E4CC"
                stroke="#C4E4CC"
                strokeMiterlimit="10"
              />
              <path
                d="M22.2138 16.6295C25.2047 11.4339 23.4297 4.79004 18.2491 1.79037C13.0686 -1.20929 6.4439 0.570932 3.45291 5.7665C0.461919 10.9621 2.23699 17.6059 7.41754 20.6056C9.13843 21.602 11.0852 22.0085 12.9391 21.9998"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path
                d="M19.2977 6.77377L9.10845 4.68546C9.10845 4.68546 8.91283 4.66675 8.84727 4.66675C8.01099 4.66675 7.32436 5.2255 7.12376 5.98263L4.07438 17.9943L3.5 19.8334L14 21.8334L16.9255 10.559L17.5528 8.10047C17.7534 7.34334 18.4489 6.78459 19.2763 6.78459L19.2977 6.77377Z"
                fill="white"
              />
              <path
                d="M12.4481 22.6684C12.2867 22.6684 12.1304 22.6471 11.9817 22.6073L1.85188 20.5315C0.992441 20.4055 0.333252 19.672 0.333252 18.7857C0.333252 18.3684 0.479464 17.9851 0.72377 17.6831C0.902918 17.4616 1.20544 17.4065 1.4845 17.4637L9.77207 19.1622C10.3935 19.2896 10.6665 20.2692 10.6665 20.9035C10.6665 21.7182 11.2241 22.4042 11.9817 22.6073L12.1869 22.6493L12.4481 22.6684Z"
                fill="#F0FAF1"
              />
              <path
                d="M12.4482 22.6683C13.1832 22.6683 13.8043 22.4428 14.0049 21.6857L10.5 21C10.5 21.9746 11.4644 22.6683 12.4482 22.6683Z"
                fill="#C4E4CC"
                stroke="#C4E4CC"
                strokeMiterlimit="10"
              />
              <path d="M12.1035 22.5658L5.59106 21.2312" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" />
              <path
                d="M14.2929 20.467L14.0883 21.269C13.8877 22.0261 13.0999 22.5849 12.3648 22.5849C11.381 22.5849 10.5832 21.7946 10.5832 20.82V20.82C10.5832 20.1857 10.3102 19.2061 9.68882 19.0787L1.40124 17.3802C1.12219 17.323 0.819666 17.3781 0.640518 17.5996C0.396212 17.9016 0.25 18.2849 0.25 18.7022C0.25 19.5885 0.909189 20.322 1.76863 20.448L6.20052 21.3562"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path
                d="M19.2766 6.70294C19.2488 6.70188 19.221 6.70117 19.1929 6.70117C18.3655 6.70117 17.67 7.25993 17.4694 8.01705L16.094 13.4077"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path
                d="M18.4742 9.53122L19.7674 9.79038C20.0452 9.84606 20.3458 9.79062 20.5243 9.57059C20.7696 9.26825 20.9165 8.88413 20.9165 8.46595C20.9165 7.57964 20.2191 6.84616 19.3601 6.72015L9.0774 4.61269C9.04252 4.60554 9.00733 4.60024 8.97186 4.59711C8.90904 4.59156 8.80755 4.58325 8.76385 4.58325C7.92757 4.58325 7.24095 5.14201 7.04034 5.89913L3.99097 17.9108"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path d="M15.928 8.85483L8.26929 7.28516" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" />
              <path d="M13.4944 10.2307L7.73486 9.05005" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" />
              <path d="M15.2168 10.5838L14.2732 10.3904" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" />
              <path d="M14.681 12.3487L7.20044 10.8149" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" />
              <path d="M11.4739 13.5841L6.66577 12.5798" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" />
              <path
                d="M19.3947 14.667C18.8602 14.3172 18.2199 14.1135 17.5315 14.1135C15.6619 14.1135 14.1465 15.6147 14.1465 17.4668C14.1465 19.3188 15.6619 20.82 17.5315 20.82C19.4011 20.82 20.9165 19.3188 20.9165 17.4668C20.9165 17.1844 20.8813 16.9101 20.815 16.6482"
                fill="white"
              />
              <path
                d="M20.3947 13.667C19.8602 13.3172 19.2199 13.1135 18.5315 13.1135C16.6619 13.1135 15.1465 14.6147 15.1465 16.4668C15.1465 18.3188 16.6619 19.82 18.5315 19.82C20.4011 19.82 21.9165 18.3188 21.9165 16.4668C21.9165 16.1844 21.8813 15.9101 21.815 15.6482"
                fill="#F0FAF1"
              />
              <path
                d="M19.3947 14.667C18.8602 14.3172 18.2199 14.1135 17.5315 14.1135C15.6619 14.1135 14.1465 15.6147 14.1465 17.4668C14.1465 19.3188 15.6619 20.82 17.5315 20.82C19.4011 20.82 20.9165 19.3188 20.9165 17.4668C20.9165 17.1844 20.8813 16.9101 20.815 16.6482"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path
                d="M16.0674 17.4284L17.1752 18.5258L20.7829 14.9519"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_807_5801">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p className="tpg_b2 hero__widget-text">E-Prescriptions</p>
        </div>

        <Cross onClick={handleClickClose} />

        <div className="hero__widget-body">
          <Input
            label="ID number"
            name="idNumber"
            value={data.idNumber}
            onChange={handleChange}
            rules={[Validators.required]}
          />
          <div className="prescription-widget-date-picker">
            <CustomDatePicker
              label="Date of birth"
              value={data.dob}
              onChange={handleChange}
              name="dob"
              maxDate={new Date()}
              showYearDropdown
              className="prescription-widget-date-picker"
            />
          </div>
          <Button
            withIcon
            rightIcon={false}
            iconType="search"
            text="Search"
            onClick={handleSubmit}
            disabled={isDisabled}
          />
        </div>
      </div>
    </>
  );
}
